import { render } from "./NewAsideMetricCard.vue?vue&type=template&id=43d72c7c&scoped=true"
import script from "./NewAsideMetricCard.vue?vue&type=script&lang=js"
export * from "./NewAsideMetricCard.vue?vue&type=script&lang=js"

import "./NewAsideMetricCard.vue?vue&type=style&index=0&id=43d72c7c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d72c7c"]])

export default __exports__